export const OPEN_POPUP = 'OPEN_POPUP';
export const LOADING_MORE_MY_BOOKLIST = 'LOADING_MORE_MY_BOOKLIST';
export const LOADING_MY_BOOKLIST = 'LOADING_MY_BOOKLIST';
export const LOADING_BOOKLIST_COLLABORATIVE = 'LOADING_BOOKLIST_COLLABORATIVE';
export const LOADING_MORE_BOOKLIST_COLLABORATIVE = 'LOADING_MORE_BOOKLIST_COLLABORATIVE';
export const GET_MY_BOOKLIST = 'FETCH_MY_BOOKLIST';
export const MORE_MY_BOOKLIST = 'MORE_MY_BOOKLIST';
export const GET_BOOKLIST_COLLABORATIVE = 'FETCH_BOOKLIST_COLLABORATIVE';
export const MORE_BOOKLIST_COLLABORATIVE = 'MORE_BOOKLIST_COLLABORATIVE';
export const RESET_CONTEXT_MENU = 'RESET_CONTEXT_MENU';